import * as S from "./ExerciseRecomBox.style";
import { request } from "@/common/api";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { ExerciseInfo } from "@/common/types/healthData";
import { useRecoilValue } from "recoil";
import { studentUserState } from "@/common/states/user";
import { GET_EXERCISE_INFO } from "@/common/querykeys";
import { ModalPointStandard } from "@/components/organisms/Modals/ModalPointStandard";
import { ReactComponent as IconArrow } from "@/styles/assets/svg/icon_play_arrow.svg";
import { ReactComponent as IconQuestion } from "@/styles/assets/svg/icon_question.svg";
import { ReactComponent as IconTimeGray } from "@/styles/assets/svg/icon_time_gray.svg";

interface ExerciseRecomBoxProps {
  type: "main" | "exercise";
  title?: string;
  onClick: () => void;
  duration?: number;
  children?: React.ReactNode;
  thumbnailUrl?: string;
}
export const ExerciseRecomBox = ({
  type,
  title,
  onClick,
  duration,
  children,
  thumbnailUrl,
}: ExerciseRecomBoxProps) => {
  const student = useRecoilValue(studentUserState);
  const [modalShow, setModalShow] = useState(false);

  const { data: exerciseInfo } = useQuery<ExerciseInfo>({
    queryKey: [GET_EXERCISE_INFO],
    queryFn: async () => {
      return await request<ExerciseInfo>({
        method: "GET",
        url: `/exercise/exercise-info/${student.id}`,
      });
    },
  });

  const formatDuration = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    if (minutes === 0) {
      return `${remainingSeconds}초`;
    }

    return remainingSeconds > 0
      ? `${minutes}분 ${remainingSeconds}초`
      : `${minutes}분`;
  };

  let remainingDays = 0;
  if (exerciseInfo?.diffDays && exerciseInfo?.diffDays !== 0) {
    remainingDays = 84 - exerciseInfo?.diffDays;
  }

  /** 메인 페이지 운동추천 컴포넌트 **/
  if (type === "main") {
    return (
      <>
        <S.MainExerciseBox>
          <S.MainExerciseTit>
            12주 운동 프로그램
            <div onClick={() => setModalShow(true)}>
              <IconQuestion />
            </div>
          </S.MainExerciseTit>

          <S.MainExerciseRecomBox>
            <S.MainExerciseRecomTit>
              나의 운동 프로그램
              {remainingDays > 0 ? (
                <S.DdayBox>D-{remainingDays}</S.DdayBox>
              ) : (
                <></>
              )}
            </S.MainExerciseRecomTit>
            <S.MainExerciseRecomText>
              D-day 나의 운동 프로그램 기간을 의미합니다
            </S.MainExerciseRecomText>
            <S.MainExerciseRecomSubText>
              84일 동안 총 36회 운동 실천하여 건강한 변화를 만들어보세요
            </S.MainExerciseRecomSubText>

            <S.MainExerciseRecom>
              <S.MainExerciseThumbnail>
                <img src={thumbnailUrl} alt="운동 미리 보기" />
              </S.MainExerciseThumbnail>
              <S.MainExerciseInfo onClick={onClick}>
                <S.MainInfoTit>
                  {title}

                  {title && duration !== undefined && (
                    <S.MainWeekInfoTime>
                      <IconTimeGray /> 총 {formatDuration(duration)}
                    </S.MainWeekInfoTime>
                  )}
                </S.MainInfoTit>

                <S.MainIconBox>
                  <IconArrow width={28} height={28} />
                </S.MainIconBox>
              </S.MainExerciseInfo>
            </S.MainExerciseRecom>
          </S.MainExerciseRecomBox>

          {children}
        </S.MainExerciseBox>
        {modalShow && <ModalPointStandard setModalShow={setModalShow} />}
      </>
    );
  } else {
    return (
      <S.WeekExerciseRecomBox>
        <S.ExerciseRecom onClick={onClick}>
          <S.WeekExerciseThumbnail>
            <img src={thumbnailUrl} alt="운동 미리 보기" />
          </S.WeekExerciseThumbnail>
          <S.WeekExerciseInfo>
            <S.WeekInfoTit>
              {title}
              {title && duration !== undefined && (
                <S.WeekInfoTime>
                  <IconTimeGray /> 총 {formatDuration(duration)}
                </S.WeekInfoTime>
              )}
            </S.WeekInfoTit>
          </S.WeekExerciseInfo>
        </S.ExerciseRecom>
      </S.WeekExerciseRecomBox>
    );
  }
};
